import styled from "styled-components";
import { styled as muiStyled } from "@mui/material/styles";

import { IconButton } from "@mui/material";
import MuiDrawer from '@mui/material/Drawer';

import CloseIcon from "@mui/icons-material/Close";

import font from "src/styles/font";

const Drawer = muiStyled(MuiDrawer)(({ theme }) => ({
  "& .MuiPaper-root": {
    maxHeight: "90dvh",
    borderRadius: "32px 32px 0 0",
    display: "block",
    overflow: "hidden",
  },
}));

const Container = styled.div`
  width: 100%;
  height: 100%;
  max-height: 90dvh;
  display: flex;
  flex-direction: column;
  position: relative;
`

const Title = styled.div`
  width: 100%;
  flex: 0 0 auto;
  position: relative;
  padding: 24px;
`

const TitleText = styled.div`
  width: 100%;
  font-size: ${font.size.md};
  font-weight: 600;
  text-align: center;
`

const BottonSheet = ({
  children,
  title,
  onClose,
  open,
}) => {
  return (
    <>
      <Drawer
        anchor="bottom"
        open={open}
        onClose={onClose}
      >
        <Container>
          <Title>
            <TitleText>{title}</TitleText>
            
            <IconButton
              aria-label="close"
              onClick={onClose}
              sx={{
                borderRadius: "50%",
                border: "1px solid var(--lightgrey-color)",
                position: "absolute",
                right: 16,
                top: 16,
                color: "var(--primary-color)",
              }}
            >
              <CloseIcon fontSize="small" />
            </IconButton>
          </Title>

          {children}
        </Container>
      </Drawer>
    </>
  )
};

export default BottonSheet;
